export const VALUES = {
  pickerDebounceTime: 200,
  labelsPageSize: 50,
  labelsInitialLoadCount: 100,
  milestonesPageSize: 100,
  milestonesMaxPreloadCount: 1000,
  organizationsMaxPreloadCount: 1000,
  organizationsPageSize: 100,
  maximumSuggestedUsers: 30,
}
